import { Helmet } from "fusion-plugin-react-helmet-async";
import Footer from "../shared/components/footer";
import Navbar from "../shared/components/navbar";
import { assetUrl } from "fusion-core";
import { useNavigate } from "fusion-plugin-react-router";

const mainCss = assetUrl("../styles/main.css");
const notFound = assetUrl("../assets/icons/notFound.svg");

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="stylesheet" href={mainCss} />
      </Helmet>

      <Navbar />
      <div className="tw-relative tw-min-h-[calc(100vh-200px)] tw-py-[5%] max-[480px]:tw-min-h-[calc(100vh-280px)] tw-bg-dis-page tw-text-dis-text-2 [&_h1]:tw-text-dis-navy [&_h2]:tw-text-dis-navy [&_h3]:tw-text-dis-navy [&_p]:tw-text-dis-text-2 [&_label]:tw-text-dis-text [&_li]:tw-text-dis-text-2 [&_a]:tw-text-dis-deep-blue">
        <div className="tw-flex">
          <div className="tw-mx-auto tw-w-full tw-max-w-[600px] tw-rounded-[14px] tw-border tw-border-dis-border tw-bg-white tw-px-[18px] md:tw-px-10 [&_p]:tw-text-dis-base">
            <img src={notFound} className="tw-mt-[30px] tw-h-auto tw-w-full tw-rounded-[10px]" />
            <h1 className="tw-mt-[30px]">
              Signals got crossed, and we can't find your page
            </h1>
            <p className="tw-mt-[15px] tw-mb-0">
              Let's get you where you want to go. Please check your URL or
              select one of the destinations below.
            </p>

            <button
              className="tw-block tw-w-full tw-cursor-pointer tw-rounded-dis-pill tw-border-2 tw-border-dis-sky tw-bg-dis-sky tw-px-2.5 tw-py-3.5 tw-text-center tw-text-base tw-font-bold tw-text-dis-navy tw-no-underline [caret-color:transparent] hover:tw-border-dis-sky-hover hover:tw-bg-dis-sky-hover tw-mt-[30px] tw-mb-[30px]"
              type="button"
              onClick={() => {
                navigate(-1);
              }}
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
